export default __webpack_public_path__ + "static/media/banner-image.7103cb28.png";